const columns = () => {
  return [
    {
      formItem: {
        type: "hidden",
      },
      name: "id",
      dataIndex: 'userName',
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {
        width: 100
      },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {
        width: 100
      },
    },
    {
      title: "手机号",
      name: "mobile",
      dataIndex: "mobile",
      tableItem: {},
      width: 130
    },
    {
      title: "身份证号/工号",
      name: "idCard",
      dataIndex: "idCard",
      tableItem: {
        width: 220
      },
    },
    {
      title: "用户属性",
      name: "userType",
      dataIndex: "userType",
      tableItem: {
        width: 150
      },
      dict: [
        {code: 0, codeName: "学员"},
        {code: 1, codeName: "SGM总部"},
        {code: 2, codeName: "SGM区域"},
        {code: 3, codeName: "供应商"}
      ]
    },
    {
      title: "状态",
      name: "status",
      dataIndex: "status",
      tableItem: {
        width: 100
      },
      dict: [
        {code: 0, codeName: "未签到"},
        {code: 1, codeName: "已签到"},
        {code: 2, codeName: "补签"}
      ]
    },


  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'studentSign/listByPage',
    ...api
  }
};

const classStudentSign = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowTitle: 'userName',
    rowName: 'fullName',
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default classStudentSign
